import { render, staticRenderFns } from "./xyz.vue?vue&type=template&id=2cc0df94"
import script from "../../scripts/pages/xyz.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/xyz.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports